{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
{ willExpire, isProblem } = require '@trello/paid-account'
Auth = require 'app/scripts/db/auth'
isDesktop = require('@trello/browser').isDesktop()
Controller = require 'app/scripts/controller'
moment = require('moment')
NoticeBanner = require('app/common/components/notice-banner/notice-banner').default
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('board_limits')
{ trackUe } = require '@trello/analytics'
_ = require 'underscore'

module.exports = class DowngradePeriodBanner extends React.Component
  displayName: 'DowngradePeriodBanner'

  constructor: (props) ->
    super props
    @state =
      showBanner: true

    if @props.model?.typeName == 'Board'
      @org = @props.model.getOrganization()
    else if @props.model?.typeName == 'Organization'
      @org = @props.model
    else
      @org = null

    @paidAccount = @org?.get('paidAccount')
    if !@paidAccount || !willExpire(@paidAccount) || !@org.isBusinessClass()
      @state.showBanner = false
      return

    @expirationDate = moment(new Date(@paidAccount.expiresAt))
    @gracePeriod = moment(@expirationDate).subtract(30, 'days')
    @failedPaymentDate = moment(@paidAccount.dateStandingChanged)

  shouldRenderDowngradeBanner: ->
    @expirationDate? && @gracePeriod? && moment().isBefore(@expirationDate) && moment().isSameOrAfter(@gracePeriod)

  # Failed payments go to standing 4 (overdue), then ~30 days later it goes
  # to 5 (disabled -- they lose BC features). Then ~60 days later they will
  # get their product removed then standing goes back to 3 (good)
  shouldRenderForcedDowngradeBanner: ->
    @paidAccount && isProblem(@paidAccount.standing)

  dismissBanner: (bannerId) =>
    Auth.me().dismiss(bannerId)
    @setState
      bannerDismissed: true

    Analytics.sendDismissedComponentEvent
      componentType: 'banner'
      componentName: 'boardLimitsDowngradeBanner'
      source: getScreenFromUrl()
      containers:
        organization:
          id: @org?.id

    trackUe({
      category: 'banner'
      verb: 'dismisses'
      directObj: 'board limits downgrade period banner'
      method:  'by clicking dismiss in banner'
      indirectObj: "on #{@props.model?.typeName}"
      context: { teamId: @org?.id }
    })

  navigateToBillingPage: =>
    Analytics.sendClickedButtonEvent
      buttonName: 'restoreBCButton'
      source: 'boardLimitsDowngradeBanner'
      containers:
        organization:
          id: @org?.id

    trackUe({
      category: 'banner'
      verb: 'clicks'
      directObj: 'board limits downgrade period banner'
      method: 'by clicking Restore Business Class button'
      indirectObj: "on #{@props.model?.typeName}"
      context: { teamId: @org?.id }
    })
    Controller.navigate @org.getBillingUrl(), { trigger: true }

  render: t.renderable ->
    t.div =>
      if @state.bannerDismissed ||
        !@state.showBanner ||
        isDesktop ||
        !@org?.isPremium() ||
        (!@shouldRenderDowngradeBanner() && !@shouldRenderForcedDowngradeBanner())
          @props.setShown(false)
          return

      @props.setShown(true)
      if !Auth.me().isDismissed('BoardLimitsDowngradePeriod') &&
        @shouldRenderDowngradeBanner()
          t.div '.board-limits-downgrade-period-banner', =>
            t.tag NoticeBanner, {
              onDismiss: @dismissBanner.bind(@, 'BoardLimitsDowngradePeriod')
              actionButton:
                text: t.l 'restore-business-class'
                onClick: @navigateToBillingPage
            }, =>
              t.format 'downgrade-period',
                downgradeDate: @expirationDate.format('LL'),
                orgName: @org.get('displayName')

      if !Auth.me().isDismissed('BoardLimitsForcedDowngradePeriod') &&
        @shouldRenderForcedDowngradeBanner()
          t.div '.board-limits-downgrade-period-banner', =>
            t.tag NoticeBanner, {
              onDismiss: @dismissBanner.bind(@, 'BoardLimitsForcedDowngradePeriod')
              actionButton:
                text: t.l 'restore-business-class'
                onClick: @navigateToBillingPage
            }, =>
              t.format 'forced-downgrade-period',
                failedPaymentDate: @failedPaymentDate.format('LL')
                downgradeDate: @expirationDate.format('LL')
                orgName: @org.get('displayName')
